import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import MediaSelector from '../media/MediaSelector';

const FileUrlWidget = (props: WidgetProps) => {
  const { 
    id,
    value,
    required,
    disabled,
    readonly,
    label,
    schema,
    onChange,
    onBlur,
    options
  } = props;
  
  // Determine if we need to filter by file type
  let fileTypeFilter: 'all' | 'images' | 'documents' = 'all';
  
  // First check if the field has 'file-url' format, which will trigger our widget
  const isFileUrlFormat = schema && schema.format === 'file-url';
  
  // If the schema or options specify that this is for images only
  if (
    (options && options.fileType === 'image') || 
    (schema && schema.fileType === 'image') ||
    // Force fileTypeFilter to 'images' if format is 'file-url' and schema indicates it's for images
    (isFileUrlFormat && schema?.description?.toLowerCase().includes('image')) ||
    // If format contains 'image' keyword
    (schema && schema.format && typeof schema.format === 'string' && 
      (schema.format.includes('image') || schema.format.includes('img')))
  ) {
    fileTypeFilter = 'images';
  } 
  // If the schema or options specify that this is for documents only
  else if (
    (options && options.fileType === 'document') || 
    (schema && schema.fileType === 'document') ||
    // If format contains 'document' keyword
    (schema && schema.format && typeof schema.format === 'string' && 
      schema.format.includes('document'))
  ) {
    fileTypeFilter = 'documents';
  }

  // Log the widget info for debugging - remove after fixing
  // console.log('FileUrlWidget rendering', { 
  //   id, 
  //   value, 
  //   format: schema?.format, 
  //   isFileUrlFormat,
  //   fileTypeFilter,
  //   description: schema?.description
  // });

  // console.log('FileUrlWidget', { id, value, required, disabled, readonly, label, schema, onChange, onBlur, onFocus, autofocus, options });
  
  return (
    <MediaSelector
      value={value || ''}
      onChange={(newValue) => {
        onChange(newValue || undefined);
        onBlur(id, newValue || undefined);
      }}
      label={label || schema.title || (fileTypeFilter === 'images' ? 'Image URL' : 'File URL')}
      required={required}
      disabled={disabled || readonly}
      placeholder={
        schema.placeholder || 
        (options && options.placeholder) || 
        (fileTypeFilter === 'images' 
          ? 'Enter image URL or select from media library' 
          : fileTypeFilter === 'documents'
            ? 'Enter document URL or select from media library'
            : 'Enter file URL or select from media library')
      }
      fileTypeFilter={fileTypeFilter}
    />
  );
};

export default FileUrlWidget;
